import React, { createContext, ReactNode, useCallback, useState } from 'react'
import { SnackBarModel } from '../types/SnackBarModel'

export const INITIAL_SNACKBAR: SnackBarModel = {
	id: '',
	message: '',
	open: false
}

export interface SnackBarContextProps {
	snackBarData: SnackBarModel
	displaySnackBar: (snackBar: SnackBarModel) => void,
	hideSnackBar: () => void
}

export const SnackBarContext = createContext<SnackBarContextProps>({
	snackBarData: INITIAL_SNACKBAR,
	displaySnackBar: (snackBar) => {
	},
	hideSnackBar: () => {
	}
})

interface SnackBarProviderProps {
	children: ReactNode
}

export const SnackBarProvider: React.FC<SnackBarProviderProps> = ({ children }) => {
	const [snackBarData, setSnackBarData] = useState<SnackBarModel>(INITIAL_SNACKBAR)

	const hideSnackBar = () => setSnackBarData(INITIAL_SNACKBAR)

	const displaySnackBar = useCallback((snackBar: SnackBarModel) => {
		setSnackBarData(snackBar)
	}, [setSnackBarData])

	return (
		<SnackBarContext.Provider
			value={{
				snackBarData,
				displaySnackBar,
				hideSnackBar
			}}
		>
			{children}
		</SnackBarContext.Provider>
	)
}